import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { ColumnChangeBO } from '../list/list.model';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { EngagementSaveBO, EngementBO, GenerateDynamicSessionFormBO, getListCSBO, SessionFormSaveBO } from './consultation-services.modal';

import { GlobalComponent } from 'src/app/global/global.component';

@Injectable({
  providedIn: 'root'
})

export class ConsultationServices extends Subject<DataStateChangeEventArgs> {

  constructor(private http: HttpClient, public errorService: ErrorService, public global: GlobalComponent
  ) {
    super()
  }
  public outputValues(CsState: getListCSBO): void {
    this.getConsultationList(CsState).subscribe(x => super.next(x));
  }
  getConsultationList(CsState?: getListCSBO): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/Engagement/GetEngagementDetails", CsState)
      .pipe(map(
        (response: any) =>
          <any>{
            result: response['result'],
            count: response['count'],
          }
      )).pipe(map((e: any) => {
        e?.result?.forEach((ele) => {
          ele.duration = (ele.duration != null && ele.duration != undefined) ? ele.duration.toFixed(2) : null;
          ele.CSD = ele.callStartDate ;
          ele.CED = ele.callEndDate;

     
        })
        return e;
      }))
  }
  GetAllClientDropDown(url): Observable<any> {


    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  GetConsultantDropDown(url): Observable<any> {

    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  GetUserDropDown(): Observable<any> {
    let url = "";
    if (this.global.OnboardType == "CLIENT") {
      url = "api/SessionForm/EmployeeDropDownForclientportal?";
    }
    else {
      url = "api/Employee/EmployeeDropDown?";
    }


    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  SaveManualEngagement(SaveManualEngagementBo: EngagementSaveBO): Observable<any> {
    let url = "";
if(SaveManualEngagementBo.id == "00000000-0000-0000-0000-000000000000")
{
  url = "api/Engagement/SaveEngagementWithTimesheet";
}else{
  url = "api/Engagement/UpdateEngagementWithTimesheet";
}
   

    return this.http.post(url, SaveManualEngagementBo, { observe: 'response' },).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  deleteSessionEngagement(paramsData: URLSearchParams) {
    let url = "api/SessionForm/deleteSessionFormandEngagement?"
    return this.http.delete(url + paramsData, { observe: 'response', responseType: "text" }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  SaveSessionFormTemplate(data: any): Observable<any> {
    let url = "api/SessionForm/SaveSessionForm";
    return this.http.post(url, data, { observe: 'response', responseType: "text" },).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  UpdateSessionFormTemplate(data: any): Observable<any> {
    let url = "api/SessionForm/updateSessionForm";
    return this.http.post(url, data, { observe: 'response', responseType: "text" },).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  DownloadSessionForm(params: URLSearchParams): Observable<any> {
    let url = "api/SessionForm/GetSessionFormDownloadUrl?";
    return this.http.get(url + params, { observe: 'response', responseType: "text" },).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  GenerateDynamicSessionForm(getFormBo: GenerateDynamicSessionFormBO): Observable<any> {
    let url = "api/SessionForm/GetSessionFormBase64View";
    return this.http.post(url, getFormBo, { observe: 'response' },).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }


  getLovValues(paramsData: URLSearchParams): Observable<[{ Key: string, Value: string }]> {
    let url = "api/Lov/getLovDropDown?";
    return this.http.get<[{ Key: string, Value: string }]>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getServiceValues(paramsData: URLSearchParams): Observable<[{ Key: string, Value: string }]> {
    let url = "api/Engagement/GetCientServicelistDropDown?";
    return this.http.get<[{ Key: string, Value: string }]>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }


  getclientpmi(paramsData: URLSearchParams, url): Observable<[{ Key: string, Value: string }]> {
    //  let url = "api/Engagement/GetCientServicelistDropDown?";
    return this.http.get<[{ Key: string, Value: string }]>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  getServiceBasedLovType(paramsData: URLSearchParams): Observable<[{ Key: string, Value: string }]> {
    let url
    url = "api/LOV/getLovDropDown?";
    if (this.global.OnboardType == "CLIENT") {
      url = "api/ClientPortal/getLovDropDown?";
    }
    return this.http.get<[{ Key: string, Value: string }]>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  GetSpecificEngagementDetails(paramsData: URLSearchParams): Observable<[{ Key: string, Value: string }]> {
    let url = "api/Engagement/getEngagementDataList?";
    return this.http.get<[{ Key: string, Value: string }]>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
}
